export default function ArrowCircleUpRightIcon({
  size = 'w-[26px] h-[26px]',
  color = '#092F7B',
}) {
  return (
    <svg
      className={size}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0003 21.7007C18.0823 21.7007 22.2022 17.5809 22.2022 12.4988C22.2022 7.41672 18.0823 3.29687 13.0003 3.29687C7.91818 3.29687 3.79834 7.41672 3.79834 12.4988C3.79834 17.5809 7.91818 21.7007 13.0003 21.7007Z"
        stroke={color}
        strokeWidth="1.02244"
        strokeMiterlimit="10"
      />
      <path
        d="M11.083 9.81641L15.684 9.81641V14.4174"
        stroke={color}
        strokeWidth="1.11538"
        stroke-minecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3164 15.1842L15.6842 9.81641"
        stroke={color}
        strokeWidth="1.11538"
        stroke-minecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
